import React, { useState, useEffect } from 'react';
import VehiclePage from './VehiclePage';
import VehiclePublicPage from './VehiclePublicPage';
import NFCPage from './NFCPage';
import Register from './Register';
import MarketplacePage from './MarketplacePage';
import QRPage from './QRPage';
import AddVehicle from './AddVehicle';
import AdminPage from './AdminPage';
import Onboarding from './Onboarding';

const GOLD='#F5A623',DARK='#2C2C2A',NAVY='#1E3A5F',GREEN='#22C55E';
const s = {
  wrap:{minHeight:'100vh',background:'#F4F4F4',fontFamily:"'Syne',sans-serif"},
  topbar:{background:DARK,height:'58px',display:'flex',alignItems:'center',justifyContent:'space-between',padding:'0 24px',position:'sticky',top:0,zIndex:1000},
  brandIcon:{background:GOLD,width:'34px',height:'34px',borderRadius:'8px',display:'flex',alignItems:'center',justifyContent:'center',fontWeight:800,fontSize:'13px',color:DARK},
  card:{background:'#fff',border:'0.5px solid #D3D1C7',borderRadius:'14px',padding:'18px 22px',marginBottom:'12px'},
  btn:{padding:'9px 20px',borderRadius:'10px',fontSize:'13px',fontWeight:700,cursor:'pointer',border:'none',fontFamily:"'Syne',sans-serif"},
  input:{background:'#F4F4F4',border:'0.5px solid #D3D1C7',borderRadius:'9px',padding:'9px 13px',fontSize:'13px',width:'100%',fontFamily:"'Syne',sans-serif",outline:'none',boxSizing:'border-box'},
  label:{fontSize:'10px',fontWeight:700,color:'#888',textTransform:'uppercase',letterSpacing:'.4px',marginBottom:'4px',display:'block'},
};

const api = async (endpoint, options={}) => {
  const token = localStorage.getItem('token');
  const res = await fetch('/api' + endpoint, {
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: 'Bearer ' + token } : {}) },
    ...options
  });
  return res.json();
};

const getPendingNfcToken = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get('nfc_token') || localStorage.getItem('pending_nfc_token') || null;
};
const clearPendingNfcToken = () => {
  localStorage.removeItem('pending_nfc_token');
  const params = new URLSearchParams(window.location.search);
  if (params.get('nfc_token')) window.history.replaceState({}, '', window.location.pathname);
};
const activateNfcIfPending = async (userId) => {
  const nfcToken = getPendingNfcToken();
  if (!nfcToken || !userId) return false;
  await fetch('/api/public/nfc/activate', {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ nfc_token: nfcToken, user_id: userId, destination: 'account' }),
  });
  clearPendingNfcToken();
  return true;
};

function Login({ onLogin, onRegister }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [nfcMsg, setNfcMsg] = useState('');

  const params = new URLSearchParams(window.location.search);
  const nfcToken = params.get('nfc_token');

  const login = async () => {
    setLoading(true); setError('');
    try {
      const data = await api('/auth/login', { method: 'POST', body: JSON.stringify({ email, password }) });
      if (data.token) {
        localStorage.setItem('token', data.token);
        localStorage.setItem('user', JSON.stringify(data.user));
        if (nfcToken) {
          await activateNfcIfPending(data.user.id);
          setNfcMsg('Tag NFC activat! Acum când scanezi tag-ul vei intra direct în cont.');
        }
        onLogin(data.user);
      } else setError(data.error || 'Email sau parolă incorectă');
    } catch { setError('Eroare conexiune server'); }
    setLoading(false);
  };

  return (
    <div style={s.wrap}>
      <div style={s.topbar}>
        <div style={{display:'flex',alignItems:'center',gap:'10px'}}>
          <div style={s.brandIcon}>EA</div>
          <div style={{color:'#fff',fontSize:'15px',fontWeight:800}}>dosarmasina.ro <span style={{color:'rgba(255,255,255,.4)',fontSize:'10px',fontWeight:400}}>· by Premium Support Iași</span></div>
        </div>
        <button onClick={onRegister} style={{...s.btn,background:GOLD,color:DARK,padding:'6px 16px',fontSize:'12px'}}>Cont nou →</button>
      </div>
      <div style={{minHeight:'calc(100vh - 58px)',display:'flex',alignItems:'center',justifyContent:'center',padding:'24px'}}>
        <div style={{...s.card,maxWidth:'400px',width:'100%',padding:'32px'}}>
          <div style={{textAlign:'center',marginBottom:'24px'}}>
            <div style={{background:DARK,width:'56px',height:'56px',borderRadius:'14px',display:'inline-flex',alignItems:'center',justifyContent:'center',marginBottom:'12px'}}>
              <span style={{color:GOLD,fontWeight:900,fontSize:'18px'}}>EA</span>
            </div>
            <div style={{fontSize:'22px',fontWeight:800,marginBottom:'4px'}}>dosarmasina.ro</div>
            <div style={{fontSize:'13px',color:'#888'}}>by Premium Support Iași</div>
          </div>
          {nfcToken && <div style={{background:'#FEF3DC',border:'1px solid '+GOLD,borderRadius:'8px',padding:'10px 12px',fontSize:'12px',color:'#92400E',marginBottom:'12px'}}>🏷️ Autentifică-te pentru a activa tag-ul NFC.</div>}
          {nfcMsg && <div style={{background:'#DCFCE7',borderRadius:'8px',padding:'10px',fontSize:'12px',color:'#15803D',marginBottom:'12px'}}>✓ {nfcMsg}</div>}
          <div style={{marginBottom:'12px'}}><label style={s.label}>Email</label><input style={s.input} value={email} onChange={e=>setEmail(e.target.value)} placeholder="email@exemplu.ro"/></div>
          <div style={{marginBottom:'16px'}}><label style={s.label}>Parolă</label><input style={s.input} type="password" value={password} onChange={e=>setPassword(e.target.value)} onKeyDown={e=>e.key==='Enter'&&login()} placeholder="Parola ta"/></div>
          {error && <div style={{background:'#FEE2E2',borderRadius:'8px',padding:'10px',fontSize:'12px',color:'#B91C1C',marginBottom:'12px'}}>{error}</div>}
          <button onClick={login} disabled={loading} style={{...s.btn,background:GOLD,color:DARK,width:'100%',marginBottom:'10px'}}>{loading ? 'Se verifică...' : 'Intră în cont →'}</button>
          <div style={{textAlign:'center',fontSize:'12px',color:'#888'}}>Nu ai cont? <span onClick={onRegister} style={{color:DARK,fontWeight:700,cursor:'pointer'}}>Creează cont gratuit →</span></div>
        </div>
      </div>
    </div>
  );
}

function Dashboard({ user, onLogout }) {
  const [hasVehicles, setHasVehicles] = React.useState(true);
  const [autoShowAdd, setAutoShowAdd] = React.useState(false);

  React.useEffect(() => {
    api('/vehicles').then(d => {
      if (d.vehicles && d.vehicles.length === 0) {
        setHasVehicles(false);
        setAutoShowAdd(true);
      }
    });
  }, []);
  const [page, setPage] = useState('home');
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [showAddVehicleModal, setShowAddVehicleModal] = useState(false);

  React.useEffect(() => {
    if (autoShowAdd) {
      setShowAddVehicleModal(true);
      setPage('vehicles');
    }
  }, [autoShowAdd]);

  const navItems = [
    {id:'home',icon:'🏠',label:'Acasă'},
    {id:'vehicles',icon:'🚗',label:'Mașinile mele'},
    {id:'marketplace',icon:'💬',label:'Solicitări'},
    {id:'notifications',icon:'🔔',label:'Notificări'},
    {id:'qr',icon:'📱',label:'QR Coduri'},
    ...(user.role==='admin' ? [{id:'admin',icon:'👑',label:'Admin'}] : []),
  ];

  return (
    <div style={s.wrap}>
      <div style={s.topbar}>
        <div style={{display:'flex',alignItems:'center',gap:'10px'}}>
          <div style={s.brandIcon}>EA</div>
          <div style={{color:'#fff',fontSize:'15px',fontWeight:800}}>dosarmasina.ro</div>
        </div>
        <div style={{display:'flex',gap:'6px',alignItems:'center',flexWrap:'wrap'}}>
          {navItems.map(n => (
            <button key={n.id} onClick={()=>{setPage(n.id);setSelectedVehicle(null);}} style={{...s.btn,background:page===n.id||(page==='vehicle-detail'&&n.id==='vehicles')?GOLD:'rgba(255,255,255,.1)',color:page===n.id||(page==='vehicle-detail'&&n.id==='vehicles')?DARK:'rgba(255,255,255,.7)',padding:'6px 14px',fontSize:'12px'}}>
              {n.icon} {n.label}
            </button>
          ))}
          <button onClick={onLogout} style={{...s.btn,background:'rgba(255,255,255,.1)',color:'rgba(255,255,255,.7)',padding:'6px 14px',fontSize:'12px'}}>Ieși</button>
        </div>
      </div>
      <div style={{maxWidth:'960px',margin:'0 auto',padding:'20px 16px'}}>
        {page==='home' && <HomePage user={user} setPage={setPage}/>}
        {page==='vehicles' && <VehiclesPage onOpenVehicle={v=>{setSelectedVehicle(v);setPage('vehicle-detail');}}/>}
        {page==='vehicle-detail' && selectedVehicle && <VehiclePage vehicle={selectedVehicle} onBack={()=>{setSelectedVehicle(null);setPage('vehicles');}}/>}
        {page==='marketplace' && <MarketplacePage/>}
        {page==='notifications' && <NotificationsPage/>}
        {page==='qr' && <QRPage user={user}/>}
        {page==='admin' && user.role==='admin' && <AdminPage/>}
      </div>
    </div>
  );
}

function HomePage({ user, setPage }) {
  return (
    <div>
      <div style={{...s.card,background:DARK,marginBottom:'14px'}}>
        <div style={{color:'#fff',fontSize:'20px',fontWeight:800,marginBottom:'4px'}}>Bun venit, {user.first_name}! 👋</div>
        <div style={{color:'rgba(255,255,255,.5)',fontSize:'13px'}}>Platforma dosarmasina.ro · by Premium Support Iași</div>
      </div>
      <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:'12px',marginBottom:'14px'}}>
        {[
          {icon:'🚗',title:'Mașinile mele',sub:'Gestionează vehiculele',page:'vehicles',color:GOLD},
          {icon:'💬',title:'Solicitări',sub:'Trimite cereri colaboratori',page:'marketplace',color:NAVY},
          {icon:'🔔',title:'Notificări',sub:'Expirări și alerte',page:'notifications',color:GREEN},
        ].map((item,i) => (
          <div key={i} onClick={()=>setPage(item.page)} style={{...s.card,textAlign:'center',cursor:'pointer',borderTop:`3px solid ${item.color}`}}>
            <div style={{fontSize:'32px',marginBottom:'8px'}}>{item.icon}</div>
            <div style={{fontWeight:700,fontSize:'14px',marginBottom:'4px'}}>{item.title}</div>
            <div style={{fontSize:'12px',color:'#888'}}>{item.sub}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

function VehiclesPage({ onOpenVehicle }) {
  const [vehicles, setVehicles] = useState([]);
  const [showAdd, setShowAdd] = useState(false);

  useEffect(() => { loadVehicles(); }, []);

  const loadVehicles = async () => {
    const data = await api('/vehicles');
    if (data.vehicles) setVehicles(data.vehicles);
  };

  const deleteVehicle = async (e, id) => {
    e.stopPropagation();
    if (!window.confirm('Stergi aceasta masina din cont?')) return;
    await api(`/vehicles/${id}`, { method:'DELETE' });
    loadVehicles();
  };

  return (
    <div>
      {showAdd && <AddVehicle onClose={()=>setShowAdd(false)} onAdded={loadVehicles}/>}
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'14px'}}>
        <div style={{fontSize:'20px',fontWeight:800}}>🚗 Mașinile mele</div>
        <button onClick={()=>setShowAdd(true)} style={{...s.btn,background:GOLD,color:DARK}}>+ Adaugă mașină</button>
      </div>
      {vehicles.length === 0 ? (
        <div style={{...s.card,textAlign:'center',padding:'40px'}}>
          <div style={{fontSize:'48px',marginBottom:'12px'}}>🚗</div>
          <div style={{fontWeight:700,marginBottom:'6px'}}>Nu ai mașini înregistrate</div>
          <div style={{fontSize:'12px',color:'#888',marginBottom:'16px'}}>Adaugă prima mașină scanând actul sau manual</div>
          <button onClick={()=>setShowAdd(true)} style={{...s.btn,background:GOLD,color:DARK}}>+ Adaugă mașină</button>
        </div>
      ) : vehicles.map(v => (
        <div key={v.id} onClick={()=>onOpenVehicle(v)} style={{...s.card,display:'flex',justifyContent:'space-between',alignItems:'center',cursor:'pointer'}} onMouseOver={e=>e.currentTarget.style.borderColor=GOLD} onMouseOut={e=>e.currentTarget.style.borderColor='#D3D1C7'}>
          <div style={{display:'flex',alignItems:'center',gap:'14px'}}>
            <div style={{background:NAVY,borderRadius:'8px',padding:'6px 12px'}}>
              <span style={{fontFamily:'monospace',fontSize:'14px',fontWeight:700,color:GOLD,letterSpacing:'2px'}}>{v.plate_number||v.vin||'—'}</span>
            </div>
            <div>
              <div style={{fontWeight:700,fontSize:'15px'}}>{v.brand} {v.model} {v.year}</div>
              <div style={{fontSize:'11px',color:'#888',marginTop:'2px'}}>{v.fuel_type} {v.vin ? `· VIN: ${v.vin}` : ''}</div>
            </div>
          </div>
          <div style={{display:'flex',alignItems:'center',gap:'8px'}}>
            <span style={{fontSize:'11px',color:'#888'}}>Adăugat {new Date(v.created_at).toLocaleDateString('ro-RO')}</span>
            <span style={{color:GOLD,fontSize:'18px'}}>→</span>
            <button onClick={e=>deleteVehicle(e,v.id)} style={{...s.btn,background:'#FEE2E2',color:'#EF4444',padding:'5px 10px',fontSize:'11px'}}>🗑 Șterge</button>
          </div>
        </div>
      ))}
    </div>
  );
}


function NotificationsPage() {
  return (
    <div>
      <div style={{fontSize:'20px',fontWeight:800,marginBottom:'14px'}}>🔔 Notificări</div>
      <div style={{...s.card,textAlign:'center',padding:'40px'}}>
        <div style={{fontSize:'48px',marginBottom:'12px'}}>✅</div>
        <div style={{fontWeight:700,marginBottom:'6px'}}>Nu ai notificări noi</div>
        <div style={{fontSize:'12px',color:'#888'}}>Vei fi notificat cu 30, 7 și 1 zi înainte de expirarea documentelor.</div>
      </div>
    </div>
  );
}


// Verificare token public la incarcare
const checkPublicToken = async () => {
  const path = window.location.pathname;
  if (path.startsWith('/acces/')) {
    const token = path.split('/acces/')[1];
    if (token) {
      const res = await fetch('/api/public/token/' + token);
      const data = await res.json();
      if (data.token) {
        localStorage.setItem('token', data.token);
        localStorage.setItem('user', JSON.stringify(data.user));
        window.history.replaceState({}, '', '/');
        return data.user;
      }
    }
  }
  return null;
};

export default function App() {
  const [user, setUser] = useState(() => {
    const path = window.location.pathname;
    if (path.startsWith('/acces/')) {
      const pubToken = path.split('/acces/')[1];
      if (pubToken) {
        fetch('/api/public/token/' + pubToken)
          .then(r => r.json())
          .then(data => {
            if (data.token) {
              localStorage.setItem('token', data.token);
              localStorage.setItem('user', JSON.stringify(data.user));
              localStorage.setItem('qr_access', '1');
              window.history.replaceState({}, '', '/');
              setUser(data.user);
            }
          });
      }
    }
    try { const u = localStorage.getItem('user'); return u ? JSON.parse(u) : null; } catch { return null; }
  });
  const [showRegister, setShowRegister] = useState(() => window.location.pathname === '/register');
  const [confirmMsg, setConfirmMsg] = useState('');
  const [nfcActivatedMsg, setNfcActivatedMsg] = useState('');

  useEffect(() => {
    const path = window.location.pathname;
    if (path.startsWith('/confirmare/')) {
      const token = path.split('/confirmare/')[1];
      fetch(`/api/auth/confirm/${token}`)
        .then(r => r.json())
        .then(data => {
          if (data.token) {
            localStorage.setItem('token', data.token);
            localStorage.setItem('user', JSON.stringify(data.user));
            setUser(data.user);
            window.history.replaceState({}, '', '/');
          } else {
            setConfirmMsg(data.error || 'Link invalid sau expirat.');
          }
        });
    }
    // Handle NFC token from URL or localStorage
    const nfcToken = getPendingNfcToken();
    if (nfcToken) {
      if (user) {
        activateNfcIfPending(user.id).then(activated => {
          if (activated) {
            setNfcActivatedMsg('\u2713 Tag NFC activat! Acum c\u00e2nd scanezi tag-ul vei intra direct \u00een cont.');
            setTimeout(() => setNfcActivatedMsg(''), 5000);
          }
        });
      } else if (path === '/login') {
        setShowRegister(false);
      } else {
        setShowRegister(true);
      }
    }
  }, []);

  const handleLogin = async (loggedUser) => {
    const params = new URLSearchParams(window.location.search);
    const nfcToken = params.get('nfc_token');
    if (nfcToken) {
      await activateNfcIfPending(loggedUser.id);
      setNfcActivatedMsg('✓ Tag NFC activat! Acum când scanezi tag-ul vei intra direct în cont.');
      setTimeout(() => setNfcActivatedMsg(''), 5000);
    }
    setUser(loggedUser);
  };

  const logout = () => { localStorage.removeItem('token'); localStorage.removeItem('user'); setUser(null); setShowRegister(false); };

  if (window.location.pathname.startsWith('/masina/')) return <VehiclePublicPage />;
  if (window.location.pathname.startsWith('/nfc/')) return <NFCPage />;

  if (confirmMsg) return (
    <div style={{minHeight:'100vh',background:'#F4F4F4',display:'flex',alignItems:'center',justifyContent:'center',fontFamily:"'Syne',sans-serif"}}>
      <div style={{background:'#fff',borderRadius:'16px',padding:'40px',maxWidth:'400px',width:'90%',textAlign:'center',border:'0.5px solid #D3D1C7'}}>
        <div style={{fontSize:'48px',marginBottom:'16px'}}>❌</div>
        <div style={{fontWeight:800,fontSize:'18px',marginBottom:'8px'}}>Link invalid</div>
        <div style={{fontSize:'13px',color:'#888',marginBottom:'20px'}}>{confirmMsg}</div>
        <button onClick={()=>setConfirmMsg('')} style={{background:'#F5A623',color:'#2C2C2A',border:'none',borderRadius:'10px',padding:'12px 24px',fontWeight:700,cursor:'pointer',fontSize:'13px'}}>← Inapoi la login</button>
      </div>
    </div>
  );
  if (!user && showRegister) return <Register onRegister={handleLogin} onBack={()=>setShowRegister(false)}/>;
  if (!user) return <Login onLogin={handleLogin} onRegister={()=>setShowRegister(true)}/>;
  if (!user.onboarding_completed && !localStorage.getItem('qr_access')) return <Onboarding user={user} onComplete={()=>{ const u={...user,onboarding_completed:true}; localStorage.setItem('user',JSON.stringify(u)); setUser(u); }}/>;
  return (
    <>
      {nfcActivatedMsg && (
        <div style={{position:'fixed',top:'20px',left:'50%',transform:'translateX(-50%)',background:'#DCFCE7',border:'1px solid #86EFAC',borderRadius:'10px',padding:'12px 20px',fontSize:'13px',color:'#15803D',fontWeight:600,zIndex:99999,fontFamily:"'Syne',sans-serif",boxShadow:'0 4px 12px rgba(0,0,0,.1)'}}>
          {nfcActivatedMsg}
        </div>
      )}
      <Dashboard user={user} onLogout={logout}/>
    </>
  );
}
